export default __webpack_public_path__ + "static/media/goutam-bakshi.9012cc11.jpg";